import { render, staticRenderFns } from "./BalancePayment.vue?vue&type=template&id=31124456&scoped=true"
import script from "./BalancePayment.vue?vue&type=script&lang=js"
export * from "./BalancePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31124456",
  null
  
)

export default component.exports